<div class="col-12 px-0">
  <h3>Client Details Change Log: {{ client?.name }}</h3>
</div>
@if (!loading) {
  <div class="col-12">
    <app-pagination-header [paging]="paging" [label]="'audits'" (pageSizeChange)="onPageSizeChange($event)" />
  </div>
  <div class="audit-list-wrapper col-12">
    <table class="audit-list table table-bordered table-hover">
      <thead class="table-dark">
        <tr>
          <th>Changed At</th>
          <th>Action</th>
          <th>New Values</th>
          <th>Previous Values</th>
          <th>User</th>
        </tr>
      </thead>
      <tbody>
        @for (parsedAudit of parsedAudits; track parsedAudit) {
          <tr>
            <td>{{ parsedAudit.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
            <td>
              {{ modelNameStrings[parsedAudit.auditableType] }}
              {{ actionDisplay(parsedAudit) }}
            </td>
            <td>
              <div class="overflow-auto" style="max-height: 600px;" [innerHTML]="parsedAudit.changesHtml[1]"></div>
            </td>
            <td>
              <div class="overflow-auto" style="max-height: 600px;" [innerHTML]="parsedAudit.changesHtml[0]"></div>
            </td>
            <td>{{ parsedAudit.user?.email }}</td>
          </tr>
        }
      </tbody>
    </table>
    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  </div>
} @else {
  <mat-spinner />
}
